module.exports = __webpack_public_path__ + "img/icon1.b72caa8f.png";